import React from 'react'
import { useTranslation } from 'react-i18next';
import HeaderIcons from '../../shared/HeaderIcons';
import { Line } from 'react-chartjs-2';

const PmrEvolution = ({
    IconMult,
    IconExcl,
    IconSatis,
    isLoan,
    isIgr,
    chartDataLine,
    chartOptions
}) => {
    const { t } = useTranslation();

    return (
        <>
            <h3 className="title-components">{t('extended_report.PMR_evolution')}</h3>
            <div className='pmr-evolution'>
                <div className='stages-projects'>
                    <p className='text-one'>{t('extended_report.projects_in_stages_ll_and_lll')}</p>
                    <p className='text-two'>{t('extended_report.reclassification')}</p>
                </div>

                <div className='indicators-composition'>
                    <HeaderIcons Icon={IconMult} text={`${t('one_pager_report.problems')}`} />
                    <HeaderIcons Icon={IconExcl} text={`${t('one_pager_report.alert')}`} />
                    <HeaderIcons Icon={IconSatis} text={`${t('one_pager_report.satisfactory')}`} />
                </div>
            </div>
            {(isLoan | isIgr) ? (
                <div className='line-chart'>
                    <Line data={chartDataLine} options={chartOptions} />
                </div>
            ) : (
                <div className='na-content'>
                    <p>N/A</p>
                </div>
            )}
        </>
    )
}

export default PmrEvolution